<template>
  <dx-broker-offer-intro product="small-business" />
</template>

<script>
import DxBrokerOfferIntro from '~/domains/brokerOffer/components/DX-BrokerOfferIntro'

export default {
  name: 'BrokerOfferSmallBusinessIntro',
  components: {
    DxBrokerOfferIntro,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de:
        '/partnerportal/unternehmensrechtsschutz/small-business/antragsstrecke/',
      fr:
        '/portailpartenaires/protection-juridique-entreprise/small-business/formulaire-de-demande/',
    },
  },
}
</script>
